import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {CompanyDto} from "../../model/CompanyDto";
import * as angular from "angular";
import {CaseTypeDto} from "../../model/CaseTypeDto";

export default class ListController implements Ng1Controller {
    private records: CompanyDto[] = [];
    private model: CompanyDto;
    private caseTypes: CaseTypeDto[] = [];

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any) {
        $dataHub.client.bindAllCompany(() => this.records);
        $dataHub.client.bindAllCaseType(() => this.caseTypes);
        $dataHub.onConnected(this.refresh);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.server.companySubscribe(null)
            .catch(this.$dataHub.defaultErrorHandler);
        this.$dataHub.server.caseTypeSubscribe()
            .catch(this.$dataHub.defaultErrorHandler);
    };

    create() {
        this.model = new CompanyDto();
        this.model.isActive = true;
    }

    edit(company) {
        this.model = angular.copy(company);
    }

    save() {
        this.$dataHub.server.companySave(this.model)
            .then(() => {
                this.model = null;
                $('#companyModal').modal('hide');
            })
            .catch(this.$dataHub.defaultErrorHandler);
    }
}

